import { surveysSlice } from "./surveysSlice";
import * as actions from "./surveysActions";
import * as selectors from "./surveysSelectors";

export { actions, selectors };
export default surveysSlice.reducer;
